var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "d-flex flex-wrap ga-4",
      attrs: { "data-qa": "diagram_gender" },
    },
    [
      _c(
        "div",
        {
          staticClass: "d-flex align-center gc-1",
          attrs: { "data-qa": "diagram_gender_woman" },
        },
        [
          _c("span", {
            staticClass:
              "ui-icon-gender-female ui-icon-fz-medium primary--text",
          }),
          _vm._v(" "),
          _c("span", { staticClass: "text-body-2" }, [
            _vm._v("\n      Женщины – "),
            _c("span", { staticClass: "text-subtitle-2" }, [
              _vm._v(
                _vm._s(
                  _setup.context.doctor_practice.patients_women_frequency
                ) + "%"
              ),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "d-flex align-center gc-1",
          attrs: { "data-qa": "diagram_gender_man" },
        },
        [
          _c("span", {
            staticClass: "ui-icon-gender-male ui-icon-fz-medium primary--text",
          }),
          _vm._v(" "),
          _c("span", { staticClass: "text-body-2" }, [
            _vm._v("\n      Мужчины – "),
            _c("span", { staticClass: "text-subtitle-2" }, [
              _vm._v(
                _vm._s(_setup.context.doctor_practice.patients_men_frequency) +
                  "%"
              ),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }